import { render, staticRenderFns } from "./contract-market.vue?vue&type=template&id=f0e263c4&"
import script from "./contract-market.vue?vue&type=script&lang=js&"
export * from "./contract-market.vue?vue&type=script&lang=js&"
import style0 from "./contract-market.vue?vue&type=style&index=0&id=f0e263c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports